import apiClient from "@/services/axios";
import moment from "moment";
import JsPDF from "jspdf";
import { Modal } from "ant-design-vue";

let {
  fixArabicParentheses,
  totalPtsTreshold,
  studentCount,
  bulletinfOnTwoPages,
  bulletinColors,
  fuseSubSubjects,
  waitLoadingImage,
  getLogoWidth,
  loadImage,
  roundRect,
  rgbToHex,
  getCertificationNameByMoyenne,
} = require("./common");
const drawModuleHeaderMondial = function (doc, ctx, startY, title) {
  // module title
  let x = 65;
  let y = 63 + startY;
  let width = 125;
  doc.setFillColor(0xff, 0xff, 0xff);
  doc.setDrawColor(0xff, 0xff, 0xff);
  //doc.rect(x, y + 20, width + 10, 10, "FD");

  // module header shapes
  x = 95;
  y = 72.6 + startY;
  width = 109;
  doc.setFillColor(...bulletinColors.color2);
  // المادة rect
  roundRect(ctx, x, y, width, 7.5, {}, true, true);

  x = 139 - 60;
  y = 72.6 + startY;
  width = 16;
  doc.setFillColor(...bulletinColors.color6);
  roundRect(ctx, x, y, width, 7.4, {}, true, true);

  doc.setLineWidth(0.4);
  doc.setFillColor(...bulletinColors.color6);
  doc.setDrawColor(...bulletinColors.color2);
  doc.rect(124 - 60, 72.3 + startY, 15, 8, "FD");
  doc.rect(86 - 60, 72.3 + startY, 38, 8, "FD");
  doc.rect(65 - 60, 72.3 + startY, 10, 8, "FD");
  doc.rect(75 - 60, 72.3 + startY, 10, 8, "FD");

  // doc.line(155 - 60, 80.3 + startY, 202.5, 80.3 + startY);

  // Add new rectangle for "Module"
  x = 202.5 - 60;
  y = 72.3 + startY;
  width = 25;
  let height = 8;
  doc.setFillColor(...bulletinColors.color2);
  doc.setDrawColor(...bulletinColors.color2);
  // doc.rect(x, y, width, height, "FD");

  // Add text "Module" inside the new rectangle
  doc.setFont("Amiri", "Bold");
  doc.setFontSize(13);
  doc.setTextColor(0xff, 0xff, 0xff);
  let text = "المجال";
  let textWidth = doc.getTextWidth(text);
  doc.text(text, 171, y + height - 2);

  doc.setFont("Amiri", "Bold");
  text = "المادة";
  width = doc.getTextWidth(text);
  doc.text(text, 179 - 60, 78 + startY);

  text = "العدد / 20";
  doc.setFontSize(9);
  doc.setTextColor(...bulletinColors.color2);
  width = doc.getTextWidth(text);
  doc.text(text, 141 - 60, 78 + startY);

  text = "معدل\nالمجال";
  doc.setFontSize(9);
  doc.setTextColor(...bulletinColors.color2);
  width = doc.getTextWidth(text);
  doc.text(text, 132 - 60, 75.2 + startY, "center");

  text = "توصيّات المدّرس";
  doc.setFontSize(11);
  doc.setTextColor(...bulletinColors.color2);
  width = doc.getTextWidth(text);
  doc.text(text, 94 - 60, 77.5 + startY);

  text = "أعلى\nعدد بالقسم";
  doc.setFontSize(6);
  doc.setTextColor(...bulletinColors.color2);
  width = doc.getTextWidth(text);
  doc.text(text, 80 - 60, 75 + startY, { align: "center" });

  text = "أدنى\nعدد بالقسم";
  doc.setFontSize(6);
  doc.setTextColor(...bulletinColors.color2);
  width = doc.getTextWidth(text);
  doc.text(text, 70 - 60, 75 + startY, { align: "center" });
};

const drawBulletinpythagore = async function (
  doc,
  bulletinData,
  affichageBulletin,
  config
) {
  const { selectedTrimester, settings, schoolarYearName, selectedLevel } =
    config;
  let topMargin = -15;
  const pdf_width = doc.internal.pageSize.width;
  let width = 0;

  let arrayOfImages = settings.image;
  let imgData;
  let buildingName = "";

  // logo
  try {
    for (var i = 0; i < arrayOfImages.length; i++) {
      if (settings.activeBuilding === arrayOfImages[i].db) {
        imgData = new Image();
        imgData.src = arrayOfImages[i].logo;
        buildingName = arrayOfImages[i].name;
      }
    }
    doc.addImage(imgData, "JPEG", pdf_width - 30, 5, 20, 20);
  } catch (error) {
    console.info("Logo not found");
  }

  doc.setFont("Amiri", "normal");

  doc.setTextColor(99, 87, 91);
  doc.setFontSize(12);
  let text = "École : " + buildingName;
  doc.text(text, 15, 12);
  text = "Année scolaire : " + schoolarYearName;
  doc.text(text, 15, 20);

  const className = bulletinData.classroomName;

  // student classroom
  text = "Classe : " + className;
  doc.text(text, 110, 12);

  // student name
  text = "Élève : " + bulletinData.fullName;
  doc.text(text, 110, 20);

  // trimester text
  doc.setFontSize(20);
  doc.setFont("Amiri", "normal");
  doc.setTextColor(67, 62, 63);
  let title = "";
  switch (selectedTrimester) {
    case "1":
      title = "Relevé des notes - 1er trimestre";
      break;
    case "2":
      title = "Relevé des notes - 2ème trimestre";
      break;
    case "3":
      title = "Relevé des notes - 3ème trimestre";
      break;
  }
  width = doc.getTextWidth(title);
  doc.text(title, pdf_width / 2 - width / 2, 37);

  const cellToDelete = {};
  // Show appreciation instead of moyenne for levels 1 and 2
  const affichageMoy =
    selectedLevel && (selectedLevel === 1 || selectedLevel === 2)
      ? false
      : affichageBulletin.moyModule;

  bulletinData.modules.forEach((m) => {
    let arr = [];
    let array = [];

    m.subjects.forEach((c) => {
      arr[0] = {
        content: c.name,
        styles: {
          halign: "center",
          valign: "middle",
          fillColor: "#55a1f1",
          fontSize: 10,
          textColor: "#ffffff",
        },
      };

      arr[1] = {
        content: c.coef,
        styles: {
          halign: "center",
          valign: "middle",
          fillColor: "#55a1f1",
          fontSize: 10,
          textColor: "#ffffff",
        },
      };
      arr[2] = {
        content: c.mark ?? "--",
        styles: {
          halign: "center",
          fontSize: 10,
          valign: "middle",
        },
      };

      //best mark
      arr[3] = {
        content: c.max,
        styles: {
          halign: "center",
          valign: "middle",
          fontSize: 10,
        },
      };

      //lowest mark
      arr[4] = {
        content: c.min,
        styles: {
          halign: "center",
          valign: "middle",
          fontSize: 10,
        },
      };

      arr[5] = cellToDelete;
      array.push(arr);
      arr = [];
    });
    if (affichageMoy)
      //end shifting
      array[0][5] = {
        halign: "center",
        valign: "middle",
        fontSize: 13,
        content: m.moyenne,
        rowSpan: array.length,
      };
    else {
      //affichage appréciation
      array[0][5] = {
        halign: "center",
        valign: "middle",
        fontSize: 13,
        content: m.appreciation
          ? fixArabicParentheses(m.appreciation.trim())
          : "",
        rowSpan: array.length,
      };
    }
    for (let row = 0; row < array.length; row++) {
      array[row] = array[row].filter((cell) => cell !== cellToDelete);
    }

    doc.autoTable({
      startY: 60 + topMargin,
      theme: "grid",
      styles: {
        font: "Amiri",
        halign: "center",
        valign: "middle",
        fontStyle: "Bold",
      },
      cellPadding: 0,
      headStyles: {
        fillColor: "#3e93ef",
        fontSize: 10,
        lineColor: [255, 255, 255],
        lineWidth: 0.1,
      },
      head: [
        [
          {
            content: m.name,
            colSpan: 6,
            styles: {
              halign: "center",
              fillColor: "#187fec",
              lineColor: [255, 255, 255],
              fontSize: 15,
              textColor: "#ffffff",
              font: /[a-zA-Z]/.test(m.name) ? "Amiri" : "Noto Sans Arabic",
              fontStyle: "Bold",
            },
          },
        ],
        affichageMoy
          ? [
              "Matière",
              "Coef",
              "Note",
              "Note la plus haute",
              "Note la plus basse",
              "Moyenne de module",
            ]
          : [
              "Matière",
              "Coef",
              "Note",
              "Note la plus haute",
              "Note la plus basse",
              "Appréciation",
            ],
      ],
      body: array,
      margin: {},
      didDrawPage: function (data) {
        // Reseting top margin. The change will be reflected only after print the first page.
        data.settings.margin.top = 10;
        bulletinfOnTwoPages = doc.internal.getNumberOfPages() > studentCount;
      },
      columnStyles: affichageMoy
        ? {
            0: { cellWidth: 58 },
            1: { cellWidth: 14 },
            2: { cellWidth: 15 },
            3: { cellWidth: 30 },
            4: { cellWidth: 30 },
            5: { cellWidth: 34 },
          }
        : {
            0: { cellWidth: 60 },
            1: { cellWidth: 12 },
            2: { cellWidth: 14 },
            3: { cellWidth: 25 },
            4: { cellWidth: 25 },
            5: { cellWidth: 46 },
          },
    });

    topMargin = doc.lastAutoTable.finalY - 55;
  });

  if (affichageBulletin?.side?.moyenne?.allow) {
    doc.autoTable({
      startY: 60 + topMargin,
      theme: "grid",
      styles: {
        font: "Amiri",
        halign: "center",
        valign: "middle",
        fontStyle: "Bold",
        fontSize: 14,
      },
      cellPadding: 0,
      headStyles: {
        fontSize: 11,
        lineColor: [255, 255, 255],
        lineWidth: 0.1,
      },
      head: [
        [
          affichageBulletin.specificName,
          "Moyenne la plus haute",
          "Moyenne la plus basse",
        ],
      ],
      body: [
        [
          bulletinData.moyenne,
          bulletinData.maxMoyenne,
          bulletinData.minMoyenne,
        ],
      ],
      didDrawPage: function (data) {
        // Reseting top margin. The change will be reflected only after print the first page.
        data.settings.margin.top = 10;
        bulletinfOnTwoPages = doc.internal.getNumberOfPages() > studentCount;
      },

      columnStyles: {
        0: { cellWidth: 61 },
        1: { cellWidth: 61 },
        2: { cellWidth: 61 },
      },
    });

    topMargin = doc.lastAutoTable.finalY - 55;
  }

  if (
    affichageBulletin?.side?.peda?.allow ||
    affichageBulletin?.side?.personalized?.allow
  ) {
    let perMoyenne = "--";
    if (
      affichageBulletin?.side?.personalized?.allow &&
      bulletinData.pedaMoyenne != "--" &&
      bulletinData.moyenne != "--"
    ) {
      const totalCoef =
        affichageBulletin.side.personalized.coefPeda +
        affichageBulletin.side.personalized.coefMoy;
      perMoyenne = String(
        (
          (Number(bulletinData.moyenne) *
            affichageBulletin.side.personalized.coefMoy +
            Number(bulletinData.pedaMoyenne) *
              affichageBulletin.side.personalized.coefPeda) /
          totalCoef
        ).toFixed(2)
      );
    }
    const head = [];
    const body = [];
    let tableWidth = 0;
    if (affichageBulletin?.side?.peda?.allow) {
      head.push(affichageBulletin?.side?.peda?.name);
      body.push(bulletinData.pedaMoyenne);
      tableWidth += 61;
    }

    if (affichageBulletin?.side?.personalized?.allow) {
      head.push(affichageBulletin?.side?.personalized?.name);
      body.push(perMoyenne);
      tableWidth += 61;
    }

    let margin = (pdf_width - tableWidth) / 2;

    doc.autoTable({
      startY: 60 + topMargin,
      theme: "grid",
      styles: {
        font: "Amiri",
        halign: "center",
        valign: "middle",
        fontStyle: "Bold",
        fontSize: 14,
      },
      cellPadding: 0,
      headStyles: {
        fontSize: 11,
        lineColor: [255, 255, 255],
        lineWidth: 0.1,
      },
      head: [head],
      body: [body],
      margin: { left: margin, right: margin },
      didDrawPage: function (data) {
        // Reseting top margin. The change will be reflected only after print the first page.
        data.settings.margin.top = 10;
        bulletinfOnTwoPages = doc.internal.getNumberOfPages() > studentCount;
      },

      columnStyles: {
        0: { cellWidth: 61 },
        1: { cellWidth: 61 },
      },
    });

    topMargin = doc.lastAutoTable.finalY - 55;
  }
};

const printBulletin = async function (affichageData, _, bulletinData, config) {
  const { schoolDetails, selectedStudentName, settings, bulletinType } = config;
  const doc = new JsPDF();
  //stamp
  let stamp = settings.resourcesUrl.replace("FILE_PATH", schoolDetails.stamp);
  const stampImage = new Image(30, 30);
  if (stamp) stampImage.src = stamp;
  if (stamp) {
    try {
      await waitLoadingImage(stampImage);
    } catch (e) {}
  }
  //end stamp
  if (
    affichageData.body.fuseSubjects &&
    affichageData.body.fuseSubjects === true
  )
    bulletinData = fuseSubSubjects(bulletinData);

  await drawBulletinpythagore(doc, bulletinData, affichageData, config);
  doc.save(`Bulletin ${bulletinType} ${selectedStudentName}.pdf`);
};
const printAllBulletin = async function (
  affichageData,
  _,
  bulletinsData,
  config
) {
  const { schoolDetails, settings, selectedClassName } = config;
  const doc = new JsPDF();
  //stamp
  let stamp = settings.resourcesUrl.replace("FILE_PATH", schoolDetails.stamp);
  const stampImage = new Image(30, 30);
  if (stamp) stampImage.src = stamp;
  if (stamp) {
    try {
      await waitLoadingImage(stampImage);
    } catch (e) {}
  }
  //end stamp
  let iterations = bulletinsData.length;
  for (const bulletinData of bulletinsData) {
    if (
      affichageData.body.fuseSubjects &&
      affichageData.body.fuseSubjects === true
    )
      bulletinData = fuseSubSubjects(bulletinData);

    await drawBulletinpythagore(doc, bulletinData, affichageData, config);
    if (--iterations) doc.addPage();
  }

  doc.save(`Bulletin ${selectedClassName}.pdf`);
};

export default {
  printBulletin,
  printAllBulletin,
};
